import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { HeaderElbb } from 'pages/HomeElbb/components/Header';
import { StepIndicator } from 'components/ui/StepIndicator';
import { DateRangeDisplay } from 'components/ui/DateRangeDisplay';
import { useControlDate } from 'hooks/useControlDate';
import { useModal } from 'context/ModalContext/Modal.context';
import { ParticipationConfirmedModalElbb } from 'components/ui/ParticipationConfirmedModalElbb';
import { FiList, FiVideo } from 'react-icons/fi';
import { IoCheckmarkCircle } from 'react-icons/io5';
import envelope from 'assets/img/2026/envelope.png';


const elbbSteps = [
  { icon: FiVideo as React.FunctionComponent<React.SVGProps<SVGSVGElement>>, number: 1, activeColor: 'bg-pink-bb-2', iconColor: 'text-pink-bb-2' },
  { icon: IoCheckmarkCircle as React.FunctionComponent<React.SVGProps<SVGSVGElement>>, number: 2, activeColor: 'bg-pink-bb-2', iconColor: 'text-pink-bb-2' },
];

export function ConfirmacaoElbb() {
  const navigate = useNavigate();
  const { showModal, closeModal } = useModal();
  const periodoVotacao = useControlDate('etapa_inscricao_elbb');

  useEffect(() => {
    showModal(
      'participation-confirmed-elbb',
      <ParticipationConfirmedModalElbb onClose={closeModal} />,
      'participation-confirmed-wrapper',
    );
  }, [showModal, closeModal]);

  return (
    <div className="min-h-screen bg-gray-100">
      <HeaderElbb currentPage="iniciativas" />

      {/* Step indicator — todas as etapas ativas */}
      <div className="bg-white border-b border-gray-200 py-6">
        <div className="max-w-[1200px] mx-auto px-4">
          <StepIndicator currentStep={2} steps={elbbSteps} progressColor="bg-pink-bb-2" />
        </div>
      </div>

      <main className="px-4 py-12 pb-20">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            {/* Coluna esquerda — texto */}
            <div className="flex flex-col gap-5">
              <h1 className="text-5xl font-bold text-[#5B4FCF] leading-snug m-0" tabIndex={0}>
                A inscrição da iniciativa foi confirmada no Prêmio ELBB!
              </h1>

              <p className="text-xl text-gray-600 m-0" tabIndex={0}>
                {periodoVotacao ? (
                  <>
                    De <DateRangeDisplay
                      dataInicio={periodoVotacao.dataInicio}
                      dataFim={periodoVotacao.dataFim}
                      dateFormat="dd/MM"
                      separator=" a "
                    /> será realizada a primeira etapa de votação.
                  </>
                ) : (
                  'De 23/03 a 11/04 será realizada a primeira etapa de votação.'
                )}
              </p>

              <p className="text-xl text-gray-600 m-0" tabIndex={0}>
                Comitê ELBB (Executivos e Diretor) avalia as iniciativas inscritas de sua ELBB e seleciona as iniciativas mais relevantes para o resultado da ELBB que passam para a etapa 2
              </p>

              <p className="text-xl font-semibold text-[#5B4FCF] m-0 cursor-pointer hover:underline" tabIndex={0}>
                Fique ligado, e acompanhe o Prêmio ELBB.
              </p>

              <button
                className="bg-yellow-bb text-blue-bb border-0 rounded-lg px-8 py-3 text-sm font-extrabold cursor-pointer hover:bg-[#e6b800] transition-colors self-start mt-2"
                onClick={() => navigate('/listagem-inscricao-elbb')}
              >
                VER INICIATIVAS
              </button>
            </div>

            {/* Coluna direita — ilustração */}
            <div className="flex items-center justify-center">
              <div className="relative w-96 h-96">
                {/* Envelope */}
                <div className=" rounded-2xl flex items-center justify-center">
                  <img src={envelope} alt="Ilustração de envelope de confirmação" tabIndex={0} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
